import React from "react";

import {Alert, Box, Typography} from "@mui/material";
import {makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";

const MFA_PUSH_LOGIN_ERROR_TRANSLATION = makeLxTranslations({
    namespace: "mfaPushLoginErrorTranslations",
    translations: {
        ERROR_HEADLINE: "Fehler bei der Anmeldung in zwei Schritten. Die Aufforderung zur Besätigung wurde abgelehnt oder nicht rechtzeitig beantwortet.",
        ERROR_DESCRIPTION: "Versuchen Sie erneut sich über die Benachrichtigung in Ihrer lexoffice App anzumelden oder wählen Sie eine andere Option zur Authentifizierung.",
    }
})

export default function MfaPushLoginError() {
    const {t} = useLxTranslations(MFA_PUSH_LOGIN_ERROR_TRANSLATION);
    return (
        <>
            <Alert sx={{py: 1}} severity="error">{t("ERROR_HEADLINE")}</Alert>
            <Box justifyContent={"center"}> <Typography className="Title" variant="body2"
                                                        sx={{pt: 2, pb: 3}}>{t("ERROR_DESCRIPTION")}</Typography></Box>
        </>
    )
}